import { featuresEnabled } from "@/brands/config";
import { useClassified } from "@/contexts/classified";
export function useIsEnrichedContactFormFields() {
    var _a, _b, _c, _d, _e, _f;
    const classified = useClassified();
    const { enrichedContactFormFields } = featuresEnabled;
    /*
     * EnrichedContactFormFields is temporarily feature and since usage of the swap flag is first time used in CDP here,
     * we are not going to put extra effort in changing the BFF to provide proper enum, but rather rely on translated string.
     * In case EnrichedContactFormFields feature becomes permanent, we will adapt the implementation accordingly.
     */
    const isForSwap = (_c = (_b = (_a = classified === null || classified === void 0 ? void 0 : classified.sections) === null || _a === void 0 ? void 0 : _a.hardFacts) === null || _b === void 0 ? void 0 : _b.titleAdditions) === null || _c === void 0 ? void 0 : _c.includes("Tauschwohnung");
    return (enrichedContactFormFields &&
        !isForSwap &&
        ((_d = classified === null || classified === void 0 ? void 0 : classified.rawData) === null || _d === void 0 ? void 0 : _d.distributionType) === "RENT" &&
        (((_e = classified === null || classified === void 0 ? void 0 : classified.rawData) === null || _e === void 0 ? void 0 : _e.propertyType) === "HOUSE" ||
            ((_f = classified === null || classified === void 0 ? void 0 : classified.rawData) === null || _f === void 0 ? void 0 : _f.propertyType) === "APARTMENT"));
}
